module.exports = __webpack_public_path__ + "static/media/logo.95e46bc1.svg";